module Dashboard {
    "use strict";

    export function notificationsWidgetDirective(): ng.IDirective {
        return {
            restrict: "EA",
            scope: true,
            bindToController: { config: "=" },
            templateUrl: "notificationsWidgetTemplate.htm",
            controller: "NotificationsWidgetController as ctrl"
        }
    }

    module.directive("frendsNotificationsWidget", [notificationsWidgetDirective]);

    export class NotificationsWidgetController {
        public notifications: any[] = [];
        public config: NotificationsWidgetConfig; // Value assigned by directive bindToController
        public static $inject = ["$http", "$interval", "DashboardConfigService"];
        constructor(private $http: ng.IHttpService, private $interval: ng.IIntervalService, public dashboardConfigService: DashboardConfigService) {
            this.fetch();
            $interval(() => { this.fetch() }, 10000);
        }
        
        public fetch() {
            this.$http.post("Status/NotificationResults", { environments: this.config.environments, rangeInDays: this.config.rangeInDays}).then((response: any) => {
                if (response.data && response.data.success) {
                    this.initializeNotifications(response.data.data);
                }
            });
        }
        public getIcon(notificationType) {
            if (notificationType == "AgentNotification") {
                return "fa-cogs"
            } else if (notificationType == "ProcessNotification") {
                return "fa-circle-o-notch";
            } 
            else if (notificationType == "MonitoringNotification") {
                return "fa-bar-chart";
            } 
        }

        //If the notification is in the localstorage array of cleared notifications we check if the date on the notification from the server is newer
        //than the one saved on the client. If it is newer we push the notification to the view. If the notification does not exist in the cleared array 
        //we add the notification to the view.
        public initializeNotifications(notificationResponse: any[]) {
            let tempNotifications = [];
            for (var singleNotification of notificationResponse) {
                let index = this.getClearedNotificationIndex(singleNotification.id);
                if (index >= 0) {
                    if (moment(this.config.clearedNotifications[index].utcTimeStamp).isBefore(moment(singleNotification.utcTimeStamp))) {
                        tempNotifications.push(singleNotification);
                    }
                } else {
                    tempNotifications.push(singleNotification);
                }
            }
            this.notifications = tempNotifications;
        }

        public getClearedNotificationIndex(notificationId: string) {
            return this.config.clearedNotifications.map((el) => el.id).indexOf(notificationId);
        }

        public removeNotificationFromList(notificationId: string) {
            let index = this.notifications.map((el) => el.id).indexOf(notificationId);
            if (index >= 0) {
                this.notifications.splice(index, 1);
            }
        }

        //If a notification id exists in the localstorage cleared notifications update the timestamp with the new notification
        //If the notification does not exist add a new entry to the cleared notifications array
        public clearNotification(singleNotification: any) {
            let index = this.getClearedNotificationIndex(singleNotification.id);
            if (index >= 0) {
                this.config.clearedNotifications[index].utcTimeStamp = singleNotification.utcTimeStamp;
            } else {
                this.config.clearedNotifications.push(singleNotification);
            }
            this.removeNotificationFromList(singleNotification.id);
            this.dashboardConfigService.updateWidgetConfig(this.config);
        }

        public clearAllNotifications() {
            let tempNotifications = angular.copy(this.notifications);
            for (var singleNotification of tempNotifications) {
                this.clearNotification(singleNotification);
            }
        }

        public updateSettingsCallback(config: NotificationsWidgetConfig) { 
            this.config = config;
            this.fetch();
        }
    }
    module.controller("NotificationsWidgetController", NotificationsWidgetController);
}